import React from "react";
import { default as WTableRow } from "@mui/material/TableRow";

function TableRow(props) {
  return <WTableRow {...props} />;
}

export default TableRow;
